import StringHelper from "_utils/StringHelper";


document.addEventListener("DOMContentLoaded", () => {
  forgotPasswordPage.wire();
});


const forgotPasswordPage = {
  /*
  ==================================================
    WIRE UI ELEMENTS
  ==================================================
  */

  wire() {
    document.querySelector('#forgot-password-form')?.addEventListener('submit', (e) => this.handleSubmit(e));
    document.querySelector('.reset-button')?.addEventListener('click', (e) => this.handleSubmit(e));
  },


  /*
  ==================================================
    EVENT HANDLERS
  ==================================================
  */

  handleSubmit(e) {
    if (e) {
      e.preventDefault();
    }

    const validation = this.validateInputCredentials();

    if (validation.isValid) {
      this.submitResetPasswordRequest();
    } else {
      this.showErrorMessage({ identifier: validation.identifier, message: validation.message });
    }
  },


  /*
  ==================================================
    LOCAL UTILS
  ==================================================
  */

  checkJsonResponse(rs) {
    if (rs.ok) return rs.json();

    const ct = rs.headers.get('content-type');

    if (ct.indexOf('json') >= 0) {
      return rs.json().then((data) => { throw new Error(data.error); });
    } else if (ct.indexOf('html') >= 0) {
      throw new Error('Unknown Error (code: 740)');
    } else {
      return rs.text().then((data) => { throw new Error(data); });
    }
  },

  clearErrorState() {
    document.querySelector('.error-field').innerHTML = '';
    document.querySelector('.error')?.classList.remove('error');
  },

  showErrorMessage(err) {
    this.clearErrorState();

    if (!err || !err.message) {
      return null;
    }

    if (err) {

      if (err.identifier) {
        document.getElementById(err.identifier).classList.add('error');
      }

      const errorField = document.querySelector('.error-field');
      const errorMsg = document.createElement('span');
      errorMsg.classList.add('error-text');
      errorMsg.textContent = err.message || err;
      errorField.appendChild(errorMsg);
    }
  },
  
  submitResetPasswordRequest() {
    const button = document.querySelector('.reset-button');
    button.classList.add('loading');

    const form = document.getElementById('forgot-password-form');
    form.submit();
  },

  validateInputCredentials() {
    const emailInput = document.getElementById('email')?.value.trim();

    if (!emailInput) {
      return {
        isValid: false,
        identifier: 'email',
        message: 'Please enter your email address.',
      }
    }

    if (!StringHelper.isValidEmail(emailInput)) {
      return {
        isValid: false,
        identifier: 'email',
        message: 'Please enter a valid email address.',
      }
    }

    return {
      isValid: true,
      identifier: null,
      message: null,
    }
  },
};
